<template>
  <v-container pa-0 class="application-create">
    <v-row>
      <div class="page__title">
        <h1>{{ pageTitle }}</h1>
      </div>

      <p v-if="!newCardApplication" class="px-5">
        Przedłużenia ważności SKM można dokonać okazując wymagane dokumenty w punkcie wydawania kart lub wypełniając
        poniższy formularz.
      </p>
    </v-row>

    <application-form v-if="schemaLoaded" :schema="$schema" @submit="submitApplication" />

    <material-dialog
      confirm-text="Ok"
      :title="title"
      :text="text"
      :show="showDialog"
      :show-cancel="false"
      :width="500"
      @confirm="redirectToHome"
    />
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import { ApplicationType, formatError } from '@witkac/kartamiejska-shared';
import { schemaMixin } from '@witkac/vuetify-components';

import schema from '@/schemas/application.schema';
import ApplicationForm from '@/components/forms/ApplicationForm';
import MaterialDialog from '@/components/material/Dialog';
import { cardMixin } from '@/mixins/cardMixin';
import { connectionMixin } from '@/mixins/connection';

// @vuese
// Formularz rejestracji
// @group Start
export default {
  components: { ApplicationForm, MaterialDialog },
  mixins: [cardMixin, connectionMixin, schemaMixin],
  schema,
  props: {
    source: String
  },
  data() {
    return {
      model: {},
      schemaLoaded: false,
      showDialog: false,
      title: '',
      text: '',
      validation: undefined
    };
  },
  computed: {
    ...mapState({
      application: state => state.profile.data
    }),
    pageTitle() {
      if (this.newCardApplication) {
        return 'Złóż wniosek o kartę';
      }
      return 'Przedłuż ważność karty o rok';
    },
    newCardApplication() {
      return this.$schema.application.type.$model === ApplicationType[ApplicationType.NEW];
    }
  },
  beforeCreate() {
    this.$options.external = {
      requiredTerms: this.$store.state.terms.current.filter(terms => terms.required).map(terms => terms.id)
    };
  },
  created() {
    const allTerms = this.$store.state.terms.current;
    const requiredTerms = allTerms.filter(terms => terms.required).map(terms => terms.id);
    this.$options.external = { requiredTerms };

    schema.properties.application.properties.terms.properties = allTerms.reduce((properties, term) => {
      const key = 'term_' + term.id;
      properties[key] = {
        title: 'Zgoda',
        type: 'boolean',
        fieldRequired: term.required,
        validationMessages: {
          required: 'Zgoda musi zostać udzielona.'
        }
      };
      return properties;
    }, {});
    this.$setSchema(schema);
    this.$schema.$setData({ application: this.application });
    this.$schema.application.type.$setData(
      this.card && !this.isInactive ? ApplicationType[ApplicationType.EXTENSION] : ApplicationType[ApplicationType.NEW]
    );
    this.$schema.application.profileId.$setData(this.application && this.application.id);
    this.schemaLoaded = true;
    this.$schema.application.style.$model = 'LOGO';
    this.$store.dispatch(
      'settings/get',
      this.$schema.application.type.$model === ApplicationType[ApplicationType.NEW]
        ? 'APPLICATION_NEW_GROUPS_FORM'
        : 'APPLICATION_EXTEND_GROUPS_FORM'
    );
  },
  methods: {
    // @vuese
    // Funkcja składająca wniosek o kartę
    submitApplication() {
      const errors = this.$schema.$validateAll();
      const valid = !errors.length;
      if (!valid) {
        this.showDialog = true;
        this.validation = false;
        this.title = 'Nie udało się złożyć wniosku.';
        this.text = 'Należy poprawić błędy w formularzu.';
        return;
      }

      this.$store
        .dispatch('application/add', this.$schema.$getData())
        .then(() => {
          this.$store.dispatch('application/list');
          this.$store.dispatch('card/list');
          this.showDialog = true;
          this.validation = true;
          this.title = 'Gratulacje';
          this.text = 'Wniosek został złożony poprawnie.';
        })
        .catch(err => {
          this.showDialog = true;
          this.validation = false;
          this.title = 'Nie udało się złożyć wniosku.';
          this.text = formatError(err);
        });
    },
    // @vuese
    // Przekierowuje na ekran główny
    redirectToHome() {
      if (this.validation) {
        this.$router.push({ name: 'home' });
      } else {
        this.showDialog = false;
      }
    }
  }
};
</script>

<style>
#exitButton {
  margin-right: 10px;
}
</style>
